import { render } from "./ExpenseTransactionsView.vue?vue&type=template&id=6a12b23d&scoped=true"
import script from "./ExpenseTransactionsView.vue?vue&type=script&lang=js"
export * from "./ExpenseTransactionsView.vue?vue&type=script&lang=js"

import "./ExpenseTransactionsView.vue?vue&type=style&index=0&id=6a12b23d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a12b23d"]])

export default __exports__